import React from 'react';
import { FiChevronDown } from 'react-icons/fi';

import TextInput from '@unserkunde/enscompare-components/src/components/inputs/TextInput';

const Select = {
  defaultProps: {
    size: TextInput.defaultProps.size,
    rightSection: <FiChevronDown />,
  },
  styles: (theme, params) => {
    const TextInputStyles = TextInput.styles(theme, params);
    return {
      input: TextInputStyles.input,
      rightSection: {
        pointerEvents: 'none',
      },
    };
  },
};

export default Select;
